import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MaintenanceKanban, MaintenanceDetail } from './Maintenance';

/**
 * Full-page wrapper for the existing kanban so the dashboard's
 * "See more · maintenance" link has somewhere to go. Kanban itself
 * already supports per-column 25-per-page pagination.
 */
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export default function MaintenanceFullPageWrapper() {
  const [tenancies, setTenancies] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/tenancies`, { credentials: 'include' })
      .then(r => r.json())
      .then(d => setTenancies(Array.isArray(d) ? d : (d.tenancies || [])))
      .catch(() => setTenancies([]));
  }, []);
  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh',
                  padding: '1.5rem 2rem' }}>
      <div style={{ maxWidth: 1600, margin: '0 auto' }}>
        <Link to="/" data-testid="back-to-dashboard"
              style={{ color: '#0073EA', textDecoration: 'none',
                       fontSize: '0.85rem' }}>
          &larr; Back to Dashboard
        </Link>
        <h1 style={{ margin: '0.6rem 0 1rem',
                     fontSize: '1.6rem', color: '#0f172a' }}>
          All Maintenance Requests
        </h1>
        <MaintenanceKanban
          key={refreshKey}
          tenancies={tenancies}
          dashboardMode={false}
          onOpenDetail={(id) => setSelectedId(id)}
        />
        {selectedId && (
          <MaintenanceDetail
            requestId={selectedId}
            onClose={() => setSelectedId(null)}
            onUpdated={() => { setSelectedId(null); setRefreshKey(k => k + 1); }}
          />
        )}
      </div>
    </div>
  );
}
